import src from "IMAGE";
export default { src, width: 770, height: 197, blurWidth: 0, blurHeight: 0};
